import { getValue } from './ConfigProvider'
import { stubIsEnabled } from './stubIsEnabled'
import { availabilityExclusions } from '../config'

const toBoolean = value => value === true || value === 'true'

export const availabilityIsEnabled = ({
  cookieVariant = '2', // 1 = variant, 2 = control
  pageType = 'search',
  isClearance = false,
  isClothing = false,
  isWhiteGoods = false,
  urlPath = ''
} = {}) => {
  const isBrandEnabled = getValue('features.availability.enabled') || false
  const isTestVariant = cookieVariant === '1' || stubIsEnabled()
  const isDirectory = pageType === 'directory'
  const isPageTypeIncluded = !isDirectory && !isClearance && !isClothing && !isWhiteGoods

  const isEnvironmentEnabled =
    typeof window !== 'undefined' ? toBoolean(window.availabilityEnabled) : toBoolean(process.env.AVAILABILITY_ENABLED)

  const isPageExcluded = availabilityExclusions.some(url => urlPath.toLowerCase().includes(url.toLowerCase()))

  return isBrandEnabled && isEnvironmentEnabled && isTestVariant && isPageTypeIncluded && !isPageExcluded
}
